document.querySelectorAll(".featured_products_new_product").forEach(function(product){
    product.addEventListener("mouseover", function(){
        this.classList.remove("hide_bg");
        if (this.children[0].children.length) {
            this.children[0].children[0].classList.add("hide_img");    
        }
    });

    product.addEventListener("mouseout", function(){
        this.classList.add("hide_bg");
        if (this.children[0].children.length) {
            this.children[0].children[0].classList.remove("hide_img");
        }
    });
});

if (document.getElementById("SortBy") != null) {
    document.getElementById("SortBy").addEventListener("change", function(){
        var url = this.value;
        var path = window.location.pathname + "?sort_by=" + url
        window.location.href = path;
    });
}

function openfootermenu(menu, svg){
    document.getElementsByClassName(menu)[0].classList.toggle("hide_mb");
    document.getElementsByClassName(svg)[0].classList.toggle("rotate");
}

if (document.getElementById("product_qty_plus") != null) {
    document.getElementById("product_qty_plus").addEventListener("click", function(){
        document.getElementsByName("plus")[0].click();
        document.getElementById("product_qty_number").textContent = document.getElementsByName("quantity")[0].value
    });   

    document.getElementById("product_qty_minus").addEventListener("click", function(){
        document.getElementsByName("minus")[0].click();
        document.getElementById("product_qty_number").textContent = document.getElementsByName("quantity")[0].value
    });
}

function on() {
    document.getElementById("overlay").style.display = "flex";
  }
  
  function off() {
    document.getElementById("overlay").style.display = "none";
  }

document.getElementById("cart_slider").addEventListener("click", function(){
    document.querySelector(".ajax_cart").classList.add("open_cart");
    on();
});

document.getElementById("Icon_Close").addEventListener("click", function(){
    document.querySelector(".ajax_cart").classList.remove("open_cart");
    off()
});

document.getElementById("overlay").addEventListener("click", function(){
    var sizeChart = document.querySelector(".size_chart");
    document.querySelector(".ajax_cart").classList.remove("open_cart");
    document.querySelector(".mobile_menu").classList.remove("open_menu");
    
    if (null !== sizeChart) {
        sizeChart.classList.remove("open_chart")
    }
    off()
});

function loaderon(){
    document.querySelector(".loader").classList.remove("hide_both")
}

function loaderoff(){
    document.querySelector(".loader").classList.add("hide_both")
}


function updatecart(url){
    loaderon();
    fetch(url).then(function (response) {
        // The API call was successful!
        return response.text();
    }).then(function (html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        document.querySelector('.ajax_cart').innerHTML =  doc.querySelector(".ajax_cart").innerHTML;
        loaderoff();
        document.querySelector(".cart_count").textContent = doc.querySelector(".cart_count").textContent;

        document.getElementById("Icon_Close").addEventListener("click", function(){
            document.querySelector(".ajax_cart").classList.remove("open_cart");
            off();
        });

        if(document.querySelector(".gift-wrapping").getAttribute("data-qty") == '0' && document.querySelector(".gift-wrapping").classList.contains("active")){
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: {
                    quantity: 0,
                    id: document.querySelector(".gift-wrapping").getAttribute("data-id")
                },
                success: function(data) {
                    updatecart('/cart/update');
                },
                error: function(responseText) {
                    console.log(responseText)
                }
            });
        }

    }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
    });
    //document.querySelector(".ajax_cart")
}

document.getElementById("Menu_Burger").addEventListener("click", function(){
    document.querySelector(".mobile_menu").classList.add("open_menu");
    on();
});

document.getElementById("Icon_Close_2").addEventListener("click", function(){
    document.querySelector(".mobile_menu").classList.remove("open_menu");
    off();
});

document.querySelectorAll(".has_mobile_submenu").forEach(function(menu){
    menu.addEventListener("click", function(){
        this.children[1].classList.toggle("rotate");
        this.children[2].classList.toggle("hide_submenu");
    });
});


document.querySelectorAll(".thumbnail_image").forEach(function(image){
    image.addEventListener("click", function(){
        document.querySelectorAll(".thumbnail_image").forEach(function(img){
            img.classList.remove("active_thumbanil");
        })

        image.classList.add("active_thumbanil");
        var url = image.getAttribute("src");
        var set = image.getAttribute("srcset");
        document.querySelector(".featured_image").setAttribute("src", url);
        document.querySelector(".featured_image").setAttribute("srcset", set);
    });
});

document.querySelectorAll(".color_swatch").forEach(function(swatch){
    swatch.addEventListener("click", function(){
        var name = swatch.getAttribute("data-name");
        swatch.parentElement.children[0].children[0].textContent = "- " + name;
        var title = swatch.getAttribute("data-title");
        var description = swatch.getAttribute("data-description");
        var image = swatch.getAttribute("data-image");
        
        if(image != ""){
            document.querySelector(".variant_image_change").setAttribute("src", image);
            document.querySelector(".variant_image_change").setAttribute("srcset", image);
        }

        if (title != "") {
            document.querySelector(".variant_title_change").textContent = title;
        }

        if (description != "") {
            document.querySelector(".variant_description_change").innerHTML = description;   
        }
    });
});

document.querySelectorAll(".color_swatch").forEach(function(swatch){
    swatch.addEventListener("click", function(){
        var name = this.previousElementSibling.value;
        document.querySelector(".main_product_title").textContent = name;
        document.getElementById("product_title").textContent = name;
    });
});

if (document.getElementsByClassName("product-form__input").length > 0) {
    document.querySelector(".product-form__input input[type=radio]:checked+label.color_swatch").click()   
}

document.querySelectorAll(".select_product").forEach(function(product){
    product.addEventListener("click", function(){
        document.querySelectorAll(".select_product").forEach(function(section){
            section.classList.remove("active");
        });
        this.classList.add("active");
        document.querySelector(".next_button").classList.remove("disabled");
    });
});

document.querySelectorAll(".section-product").forEach(function(section){
    section.addEventListener("click", function(){
        var id = this.getAttribute("section_id");
        document.querySelectorAll(".section-product").forEach(function(section){
            section.classList.remove("active");
        });

        this.classList.add("active");

        document.querySelectorAll(".section-products-shown").forEach(function(product){
            product.classList.add("hide_both");
        });

        document.getElementById(id).classList.remove("hide_both");
    });
});

function select_color(){
    document.querySelectorAll(".color-box").forEach(function(color){
        color.addEventListener("click", function(){
            document.querySelectorAll(".color-box").forEach(function(c){
                c.classList.remove("active")
            });
            this.classList.add("active");
            var name = this.getAttribute("data-name");
            var actualname = this.getAttribute("data-actual-name");
            document.getElementById("configurator_color").textContent = " " + name;
            document.getElementById("configurator_color").setAttribute("data-variant", actualname);
        })
    });

    document.querySelectorAll(".size").forEach(function(size){
        size.addEventListener("click", function(){
            document.querySelectorAll(".size").forEach(function(c){
                c.classList.remove("active")
            });
            this.classList.add("active");
            var name = this.getAttribute("data-name");
            document.getElementById("configurator_size").textContent = " " + name;
            document.getElementById("configurator_size").setAttribute("data-variant", name);
        })
    });

    document.querySelectorAll(".frequency_product").forEach(function(frequency){
        frequency.addEventListener("click", function(){
            document.querySelectorAll(".frequency_product").forEach(function(c){
                c.classList.remove("active")
            });
            this.classList.add("active");
            var name = this.getAttribute("data-name");
          		name = capitalizeFirstLetter(name);
            document.getElementById("configurator_subscription").textContent = " 2 Unterhosen alle " + name;
            document.getElementById("configurator_subscription").setAttribute("data-variant", name);
        })
    });
}

select_color();
document.querySelectorAll(".select_product").forEach(function(product){
    product.addEventListener("click", function(){
        document.querySelector(".hide_5_after_select_product").classList.remove("hide_both");
        var id = parseInt(this.getAttribute("product_id"));
        var handle = this.getAttribute("product_handle");
        var product_variant_html = ``;
        if(handle == 'trunk-abo' || handle == 'trunk-abo-neu'){
            jQuery.getJSON(window.Shopify.routes.root + 'products/trunk-abo-neu.js', function(product) {
                product_variant_html = product_variant_html + 
                    `${
                        String(product.variants.map((variant) => {
                        return `<option value="${variant.id}" data-index='${variant.title}' data-image="${variant.featured_image.src}">${variant.title}</option>`
                    })).split(",").join("")}`

                jQuery.getJSON(window.Shopify.routes.root + 'products/trunk-abo.js', function(product) {
                    product_variant_html = product_variant_html +
                    `${
                        String(product.variants.map((variant) => {
                        return `<option value="${variant.id}" data-index='${variant.title}' data-image="${variant.featured_image.src}">${variant.title}</option>`
                    })).split(",").join("")}`;

                    $(".hide5").append(`<select id="configurator_product" style="display: none">${product_variant_html}</select>`);
                })
            })
        }
        else{
            jQuery.getJSON(window.Shopify.routes.root + 'products/'+ handle +'.js', function(product) {
                product_variant_html = product_variant_html +  `
                ${
                    String(product.variants.map((variant) => {
                    return `<option value="${variant.id}" data-index='${variant.title}' data-image="${variant.featured_image.src}">${variant.title}</option>`
                })).split(",").join("")}`;

                $(".hide5").append(`<select id="configurator_product" style="display: none">${product_variant_html}</select>`);
            })
        }

        jQuery.getJSON(window.Shopify.routes.root + 'products/'+ handle +'.js', function(product) {
            $("#configurator_title").text(product.title);
            $("#configurator_imge").attr("src", product.images[1]);
            var options = product.options;
            for (let i = 0; i < options.length; i++) {
                const element = options[i];
                if (element.name.includes("Model")) {
                    var color_html = ``;
                    var values = element.values;
                    for (let j = 0; j < values.length; j++) {
                        const elementvalue = values[j].toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "").replace('ö','o').replace('ä','a').replace('ü', 'u');
                        var color_name = $($("."+elementvalue)[0]).text();
                        var color = 'https://cdn.shopify.com/s/files/1/0536/7368/9257/t/23/assets/' + elementvalue + '_50x.png';
                        color_html = color_html + `<div class="color-with-text pointer" data-name="values[j]">
                                                    <div class="color-box" style="background-image: url(${color});" data-actual-name="${values[j]}" data-name="${color_name}"></div>
                                                    <h1 class="text KNPM color_text uppercase font-28">${color_name}</h1>
                                                </div>`
                    }
                    $(".hide3").html(color_html);
                }

                if (element.name.includes("Grösse") || element.name.includes("Größe")) {
                    var values = element.values;
                    var size_html = ``;

                    for (let j = 0; j < values.length; j++) {
                        const elementvalue = values[j];
                        size_html = size_html + `<div class="size justify_center pointer" data-name="${elementvalue}">
                                                    <span class="size-text KNPM color_text uppercase font-60">${elementvalue}</span>
                                                </div>`
                    }

                    $(".product-size-container").html(size_html);
                    
                }

                if (element.name.includes("Laufzeit")) {
                    var values = element.values;
                    var html = ``;
                    for (let j = 0; j < values.length; j++) {
                        const elementvalue = values[j];
                        var image = '';
                        if (elementvalue.includes('3')) {
                            image = "https://cdn.shopify.com/s/files/1/0536/7368/9257/t/23/assets/abo-frequenz_men-3.png";
                        }
                        if (elementvalue.includes('4')) {
                            image = "https://cdn.shopify.com/s/files/1/0536/7368/9257/t/23/assets/abo-frequenz_men-4.png";
                        }
                        if (elementvalue.includes('6')) {
                            image = "https://cdn.shopify.com/s/files/1/0536/7368/9257/t/23/assets/abo-frequenz_men-6.png";
                        }

                        html = html + `<div class="box frequency_product flex justify_center pointer" data-name="${elementvalue}">
                                        <img class="max-100" src="${image}" alt="">
                                        <h1 class="title2 KNPM color_text uppercase font-28">2 Unterhosen </h1>
                                        <h2 class="sub-title KNPM uppercase font-18 color_text">alle ${elementvalue}</h2>
                                        </div>` 
                    }

                    $(".hide2").html(html);
                }


                select_color();
            }
        });
    });
});

if (document.getElementsByClassName("next_button").length > 0) {
    window.space = 30;
    document.querySelector(".next_button").addEventListener("click", function(){
        var total = document.querySelectorAll(".top_button").length;
        var loop = document.querySelectorAll(".top_button.active").length + 1;
    
        
        if (loop == 2) {
            document.querySelector(".prev_button").classList.add("disabled");
        }
    
        if (loop <= total) {
            document.querySelector('[data-target="hide'+ loop +'"]').click();
            document.querySelector(".prev_button").classList.remove("disabled");
            document.querySelector(".next_button").classList.remove("disabled");
            document.querySelectorAll(".top_button")[loop-2].classList.add("added");
            window.space = window.space - 32.5;
            if (screen.width < 750) {
                document.querySelector(".mide-conatiner").style.margin = '0 0 0 '+ window.space + '%';   
            }
        }
    
        if (loop == total) {
            document.querySelector(".next_button").classList.add("disabled");
            var color = document.getElementById("configurator_color").getAttribute("data-variant");
            var size = document.getElementById("configurator_size").getAttribute("data-variant");
            var frequency = document.getElementById("configurator_subscription").getAttribute("data-variant");

            var variantname = color + ' / ' + size + ' / ' + frequency;
            var main_select = document.getElementById("configurator_product").children;
            document.querySelector(".please_select_product").classList.add("hide_both");
            for (let index = 0; index < main_select.length; index++) {
                const variant = main_select[index];
                const dataname = variant.getAttribute("data-index");
                if (dataname == variantname) {
                    $("#configurator_title").text(color);
                    $("#configurator_imge").attr("src", variant.getAttribute("data-image"));
                }
            }
        }

        $('html, body').animate({
            scrollTop: $('[id$="__section2-abo"]').offset().top
        }, 1000);
    });


    document.querySelector(".prev_button").addEventListener("click", function(){
        var total = document.querySelectorAll(".top_button").length;
        var loop = document.querySelectorAll(".top_button.active").length - 1;
    
        console.log(loop);
        if (loop < 1) {
            document.querySelector(".prev_button").classList.add("disabled");
        }
    
        if (loop > 0) {
            document.querySelector('[data-target="hide'+ loop +'"]').click();
            document.querySelectorAll(".top_button.active")[loop].classList.remove("active");
            document.querySelector(".prev_button").classList.remove("disabled");
            document.querySelector(".next_button").classList.remove("disabled");
            document.querySelectorAll(".top_button")[loop-1].classList.remove("added");
            document.querySelectorAll(".top_button")[loop].classList.remove("added");
            window.space = window.space + 32.5;
            if (screen.width < 750) {
                document.querySelector(".mide-conatiner").style.margin = '0 0 0 '+ window.space + '%';   
            }
        }

        $('html, body').animate({
            scrollTop: $('[id$="__section2-abo"]').offset().top
        }, 1000);
    });
}

if (document.getElementsByClassName("btu-product").length > 0) {
    document.querySelector(".btu-product").addEventListener("click", function(e){
        e.preventDefault();
        var color = document.getElementById("configurator_color").getAttribute("data-variant");
        var size = document.getElementById("configurator_size").getAttribute("data-variant");
        var frequency = document.getElementById("configurator_subscription").getAttribute("data-variant");

        var variantname = color + ' / ' + size + ' / ' + frequency;
        var main_select = document.getElementById("configurator_product").children;
        for (let index = 0; index < main_select.length; index++) {
            const variant = main_select[index];
            const dataname = variant.getAttribute("data-index");
            if (dataname == variantname) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        quantity: 1,
                        id: parseInt(variant.value)
                    },
                    dataType: 'json',
                    success: function(data) {
                        updatecart('/cart/update');
                        document.querySelector(".ajax_cart").classList.add("open_cart");
                        on();
                    },
                    error: function(responseText) {
                        console.log(responseText)
                    }
                });
            }
        }
    });
}


document.querySelectorAll(".tag-filters__item").forEach(function(filter){
    filter.addEventListener("click", function(){
        document.querySelectorAll(".tag-filters__item").forEach(function(filters){
            filters.classList.remove("border_bottom");
        });
        this.classList.add("border_bottom");
        var type = this.getAttribute("data-type");
        document.querySelectorAll(".featured_products_new_product").forEach(function(product){
            if (!product.classList.contains(type)) {
                product.style.display = "none";    
            }
            else
            {
                product.style.display = "block";
            }
            
        });
    });
});



if (document.getElementsByClassName("hotspot").length > 0) {
    const selectHotspot = (e) => {
        const clickedHotspot = e.target.parentElement; 
        const container = clickedHotspot.parentElement; 
        
        // only include hotspots within same image to allow one open hotspot per image; change "container" to "document" to allow only one open hotspot for entire page:
        const hotspots = container.querySelectorAll(".lg-hotspot"); 
        hotspots.forEach(hotspot => {
            if (hotspot === clickedHotspot) {
            //hotspot.classList.toggle("lg-hotspot--selected");
            } else {
            hotspot.classList.remove("lg-hotspot--selected");
            }
        });
    }
    
    (() => {
        const buttons = document.querySelectorAll(".lg-hotspot__button");
        buttons.forEach(button => {
                        
            button.addEventListener('mouseover', function (e) { 
                var cont = button.closest('.lg-container'); 
                var hSpots = cont.querySelectorAll(".lg-hotspot");              
                hSpots.forEach(hotspot => { 
                    if (e.target.parentElement === hotspot) {
                        hotspot.classList.toggle("lg-hotspot--selected");
                    }
                });
            });

            button.addEventListener('mouseout', function (e) { 
                var cont = button.closest('.lg-container'); 
                var hSpots = cont.querySelectorAll(".lg-hotspot");               
                hSpots.forEach(hotspot => {
                    if (e.target.parentElement === hotspot) {
                        hotspot.classList.remove("lg-hotspot--selected");
                    }
                });
            });

            button.addEventListener("click", selectHotspot);
        });
    })();
}
document.querySelectorAll(".btn_hotspot").forEach(function(hotspot){
    hotspot.addEventListener("click", function(){
        document.querySelectorAll(".btn_hotspot").forEach(function(active){
            active.classList.remove("active");
        });

        this.classList.add("active");
        if(this.textContent.toLowerCase() == "damen"){
            if (!document.querySelector(".type_product.active").classList.contains("damen_type")) {
                document.querySelector(".type_product.active").classList.remove("active");
                document.querySelectorAll(".damen_type")[0].classList.add("active");
                document.querySelectorAll(".herren_type").forEach(function(herrn){
                    herrn.classList.add("hide_both");
                });
                document.querySelectorAll(".damen_type").forEach(function(herrn){
                    herrn.classList.remove("hide_both");
                });
            }
        }
        else
        {
            if (!document.querySelector(".type_product.active").classList.contains("herren_type")) {
                document.querySelector(".type_product.active").classList.remove("active");
                document.querySelectorAll(".herren_type")[0].classList.add("active");
                document.querySelectorAll(".damen_type").forEach(function(herrn){
                    herrn.classList.add("hide_both");
                });
                document.querySelectorAll(".herren_type").forEach(function(herrn){
                    herrn.classList.remove("hide_both");
                });
            }
        }

        var selecttype = document.querySelector(".type_product.active").getAttribute("data-type").toLowerCase();
        var selectbutton = document.querySelector(".btn_hotspot.active").textContent.toLowerCase();
        var classname = "." + selecttype + "." + selectbutton;
        document.querySelectorAll(".hotspot_products_to_change").forEach(function(spot){
            spot.classList.add("hide_both");
        });

        document.querySelectorAll(classname).forEach(function(add){
            add.classList.remove("hide_both")
        })
    });
});

document.querySelectorAll(".type_product").forEach(function(hotspot){
    hotspot.addEventListener("click", function(){
        document.querySelectorAll(".type_product").forEach(function(active){
            active.classList.remove("active");
        });

        this.classList.add("active");
        var selecttype = document.querySelector(".type_product.active").getAttribute("data-type").toLowerCase();
        var selectbutton = document.querySelector(".btn_hotspot.active").textContent.toLowerCase();
        var classname = "." + selecttype + "." + selectbutton;
        document.querySelectorAll(".hotspot_products_to_change").forEach(function(spot){
            spot.classList.add("hide_both");
        });

        document.querySelectorAll(classname).forEach(function(add){
            add.classList.remove("hide_both")
        })
    });
});

if (document.getElementsByClassName("btn_hotspot").length > 0) {
    document.querySelector(".btn_hotspot.active").click();   
}

function reload(){
    var html = document.querySelector(".testimonial_slider .slick-dots").outerHTML;
    document.querySelector(".slider_dot").innerHTML = html;

    document.querySelectorAll(".slider_dot ul li").forEach(function(li){
        
        li.addEventListener("click", function(){
            var id = "#" + this.children[0].getAttribute("id");
            // console.log(document.querySelector(".testimonial_slider ul li " + id));
            document.querySelector(".testimonial_slider ul li " + id).click();
            reload();
            
        });
    });
}



window.addEventListener("DOMContentLoaded", function(){
    if (document.querySelectorAll(".testimonial_slider .slick-dots").length) {
        var html = document.querySelector(".testimonial_slider .slick-dots").outerHTML;
        document.querySelector(".slider_dot").innerHTML = html;

        document.querySelectorAll(".slider_dot ul li").forEach(function(li){
            
            li.addEventListener("click", function(){
                var id = "#" + this.children[0].getAttribute("id");
                // console.log(document.querySelector(".testimonial_slider ul li " + id));
                document.querySelector(".testimonial_slider ul li " + id).click();
                reload();
                
            });
        }); 
    }
});

if (document.querySelectorAll(".size_btn").length > 0) {
    document.querySelectorAll('.toggle-tab').forEach((single,index) => {
        var css = `.toggle-tab${index + 1}.active {max-height: ${single.clientHeight + 300}px;} .toggle-tab${index + 1} {max-height: 0px;}`;
        const style = document.createElement('style');
        style.type = 'text/css';
        if (style.styleSheet){
        // This is required for IE8 and below.
        style.styleSheet.cssText = css;
        } else {
        style.appendChild(document.createTextNode(css));
        }
        document.querySelector('body').append(style);
    })

    document.querySelectorAll(".size_btn").forEach(function(btn){
        btn.addEventListener("click", function(){
            document.querySelectorAll(".size_btn").forEach(function(btn){
                btn.classList.toggle("active");
            });

            document.querySelectorAll(".toggle-tab").forEach(function(size){
                size.classList.toggle("active");
            });
        });
    });
}

var iconClose = document.getElementById("Icon_Close_3");
if (null !== iconClose) {
  document.getElementById("Icon_Close_3").addEventListener('click', function(){
      document.querySelector(".size_chart").classList.remove("open_chart");
      off();
  });
}

if (document.querySelectorAll(".size_chart_popup").length > 0) {
    document.querySelector(".size_chart_popup").addEventListener("click", function(e){
        e.preventDefault();
        document.querySelector(".size_chart").classList.add("open_chart")
        on();
    });
}

function add_or_remove_gift(id, is_gift_added, qty){
    loaderon();
    $(".gift-wrapping svg").toggleClass("hide_checkbox");
    if (is_gift_added == 'false') {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: id
            },
            dataType: 'json',
            success: function(data) {
                updatecart('/cart/update');
            },
            error: function(responseText) {
                console.log(responseText)
            }
        });
    }
    else
    {
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                quantity: 0,
                id: id
            },
            success: function(data) {
                updatecart('/cart/update');
            },
            error: function(responseText) {
                console.log(responseText)
            }
        });
    }
}

if (document.getElementsByClassName('trend-Sec1-content').length > 0) {
    var index = parseInt(document.querySelector(".number-box-content .active").getAttribute("data-index"));
    if (index > 2) {
        document.getElementsByClassName('trend-Sec1-content')[0].scrollLeft = (index-2)*120;    
    }
}


var reviewWidget = $('.template-product').find('reviewsio-product-reviews-widget');
if (reviewWidget) {
    var reviewSection = reviewWidget.closest('section');
    reviewSection.addClass('review-widget-wrapp');
}

const customerTemplates = (function() {
  
    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
  
      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }
  
    /**
     *
     *  Show/Hide recover password form
     *
     */
    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }
  
    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }
  
      // show success message
      $('#ResetSuccess').removeClass('hide');
    }
  
    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');
  
      if (!$newAddressForm.length || !$addressForms.length) {
        return;
      }
  
      if (Shopify) {
        $('.js-address-country').each(function() {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');
  
        });
      }
  
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
      });
  
      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });
    }
  
    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    return {
      init: function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  })();

customerTemplates.init();

// program to convert first letter of a string to uppercase
function capitalizeFirstLetter(str) {

    // converting first letter to uppercase
    const capitalized = str.charAt(0).toUpperCase() + str.slice(1);

    return capitalized;
}

var variantBtnLink = function() {
    var aboBtn = $('.template-product .other_btn.decoration-none');
    var varBtn = $('.template-product .var-btn');

    if (aboBtn.length > 0) {
        console.log(aboBtn.attr('href'));
        varBtn.attr('href', aboBtn.attr('href'));
    }
};

variantBtnLink();

/* Pack switcher */
const packSwitcher = function() {
    const productPacks = document.querySelector('.product_packs_div');

    if (productPacks) {
        productPacks.addEventListener('click', function(e) {
            if (e.target.classList.contains('product_pack_div')) {
                let packs = document.querySelectorAll('.product_pack_div');
                packs.forEach(function(pack) {
                    pack.classList.remove('selected');
                });

                e.target.classList.add('selected');

                console.log(window.packVariants);
            }
        });
    }
}

// packSwitcher();